import { Logo } from "../components/Title/logo";

function Closing() {
  return (
    <div className="w-screen sm:w-[500px] min-w-[340px] mx-auto bg-backgroundLightGrey">
      <div className="flex flex-col ">
        <Logo />
        <div className="pr-12 mt-4 ml-4">
          <div className="font-bold text-left text-[24px]">Thank you!</div>
          <div className="h-[3px] bg-orange w-[20%] mb-4"></div>
          <div className="relative font-light text-[16px]">
            <div>Your help is greatly appreciated.</div>
            <div>If you have any questions,</div>
            <div>feel free to reach out at</div>
            <div className="underline">kontakt@payjim.de</div>
          </div>
        </div>
        <img
          className="absolute top-[15%] max-w-[488px] min-w-[311px]"
          src="/images/Ellipse.svg"
          alt="ellipse"
          width="100%"
        />
      </div>
    </div>
  );
}

export default Closing;
